<template>
  <div class="bgGraphBase">
    <div class="posMarker">
      <span class="marker" :style="{ left: left + '%' }"></span>
      <ul class="flex">
        <li>
          <div class="resultGraph"></div>
          <span>Very Poor</span>
        </li>
        <li>
          <div class="resultGraph">8秒</div>
          <span>Poor</span>
        </li>
        <li>
          <div class="resultGraph">5秒</div>
          <span>More</span>
        </li>
        <li>
          <div class="resultGraph">3秒</div>
          <span>Good</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Number,
      required: true
    },
    isAnimate: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      left: 0,
      max: 13,
      timeout: null
    };
  },

  mounted() {
    if (this.isAnimate) {
      this.$nextTick(() => {
        this.timeout = setTimeout(() => {
          this.update();
        }, 100);
      });
    } else {
      this.update();
    }
  },

  destroyed() {
    clearTimeout(this.timeout);
  },

  methods: {
    update() {
      let left = 0;
      if (this.data > 0) {
        left = ((this.max - this.data) / this.max) * 100;
        if (left < 0) {
          left = 0;
        }
      }
      this.left = left;
    }
  }
};
</script>
